/**
 * * Статус проекта
 */
enum EnumProjectType {
	/**
	 * * Активный
	 */
	Active = 0,
	/**
	 * * В архиве
	 */
	Archived = 1
}
export default EnumProjectType
